module.exports = require('./helpers/bundle-url').getBundleURL('jtuNe') + "logo-dark.eefe0b7f.svg";